import { omit } from "ramda";
import { curryN } from "ramda";
import copyProp from "./copyProp.mjs";
export default curryN(3, (fromKey, toKey, obj) => omit([fromKey], copyProp(fromKey, toKey, obj)));
//# sourceMappingURL=moveProp.mjs.map